<div class="row m-0 px-3 py-3 overflow-none" [formGroup]="formAltaTercero">
  <div [ngClass]="[1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'">
    <div class="row">
      <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Seleccionar tercero:</mat-label>
          <mat-select formControlName="tipoTercero" placeholder="Seleccionar">
            @for (t of catTipoTercero; track t) {
              <mat-option [value]="t.valor_dato">{{ t.descripl_dato
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (this.formAltaTercero.get('tipoTercero').value) {
        @if ([1,2,3].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Tipo de persona:</mat-label>
              <mat-select formControlName="tipoPersona" placeholder="Seleccionar">
                @for (t of catTpoPersona; track t) {
                  <mat-option [value]="t.valor_dato">
                    {{ t.descripl_dato }}
                  </mat-option>
                }
              </mat-select>
              @if (formAltaTercero.get('tipoPersona').hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (this.formAltaTercero.get('tipoPersona').value == 2 && [1,2,3].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Razón Social:</mat-label>
              <input matInput type="text" formControlName="razonSocial" UpperCase>
            </mat-form-field>
          </div>
        }
        @if (![6,7,8].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-4' : 'col-md-4'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Nombre:</mat-label>
              <input matInput type="text" formControlName="nombre" UpperCase>
              @if (formAltaTercero.get('nombre').hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (![6,7,8].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-4' : 'col-md-4'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Apellido paterno:</mat-label>
              <input matInput type="text" formControlName="apellidoPaterno" UpperCase>
              @if (formAltaTercero.get('apellidoPaterno').hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (![6,7,8].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-4' : 'col-md-4'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Apellido materno:</mat-label>
              <input matInput type="text" formControlName="apellidoMaterno" UpperCase>
              @if (formAltaTercero.get('apellidoMaterno').hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if ([4,5].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Edad:</mat-label>
              <input matInput type="text" formControlName="edad" maxlength="3">
              @if (this.formAltaTercero.get('edad').hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if ([5].includes(this.formAltaTercero.get('tipoTercero').value)) {
          <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
            >
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Objeto dañado:</mat-label>
              <input matInput type="text" formControlName="objetoDanado"   [UpperCase]="true">
            </mat-form-field>
          </div>
        }
        <div class="col-md-12">
          <div class="row">
            <div class="col md-6">
              <div class="row">
                @if ([1].includes(this.formAltaTercero.get('tipoTercero').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Cobertura tercero:</mat-label>
                      <mat-select formControlName="cobertura" placeholder="Seleccionar">
                        @for (t of catCoberturas; track t) {
                          <mat-option [value]="t.valor_dato">
                            {{ t.descripl_dato }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (this.formAltaTercero.get('cobertura').hasError('pattern')) {
                        <mat-error>
                          Campo requerido
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if ([1].includes(this.formAltaTercero.get('tipoTercero').value) && ![0].includes(this.formAltaTercero.get('cobertura').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Siniestro:</mat-label>
                      <input matInput type="text" formControlName="siniestro" maxlength="20">
                    </mat-form-field>
                  </div>
                }
                @if ([1].includes(this.formAltaTercero.get('tipoTercero').value) && ![0].includes(this.formAltaTercero.get('cobertura').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Ajustador:</mat-label>
                      <input matInput type="text" formControlName="ajustador">
                    </mat-form-field>
                  </div>
                }
                @if ([1].includes(this.formAltaTercero.get('tipoTercero').value) && ![0].includes(this.formAltaTercero.get('cobertura').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Póliza:</mat-label>
                      <input matInput type="text" formControlName="poliza" maxlength="30">
                    </mat-form-field>
                  </div>
                }
                @if ([1,2,3].includes(this.formAltaTercero.get('tipoTercero').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Email:</mat-label>
                      <input matInput type="email" formControlName="email">
                      @if (this.formAltaTercero.get('email').hasError('required')) {
                        <mat-error>
                          Campo requerido
                        </mat-error>
                      }
                      @if (this.formAltaTercero.get('email').hasError('invalidEmail')) {
                        <mat-error>
                          De capturar un email válido
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if ([1,2,3].includes(this.formAltaTercero.get('tipoTercero').value)) {
                  <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Teléfono:</mat-label>
                      <input matInput type="tel" formControlName="telefono" maxlength="10"
                        [OnlyNumber]="true">
                        @if (this.formAltaTercero.get('telefono').hasError('maxlength')) {
                          <mat-error>
                            La longitud máxima es de 10 dígitos
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                  @if ([1].includes(this.formAltaTercero.get('tipoTercero').value) && ![0].includes(this.formAltaTercero.get('cobertura').value)) {
                    <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                      >
                      <mat-form-field class="inputFormularioSmall">
                        <mat-label>Compañia:</mat-label>
                        <mat-select formControlName="compania" placeholder="Seleccionar">
                          @for (t of catCompania; track t) {
                            <mat-option [value]="t.numerok">
                            {{t.numerok }} - {{ t.nombre }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (![6,7,8].includes(this.formAltaTercero.get('tipoTercero').value)) {
                    <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                      >
                      <mat-form-field class="inputFormularioSmall">
                        <mat-label>Estatus:</mat-label>
                        <mat-select formControlName="estatus" placeholder="Seleccionar">
                          @for (t of catEstatus; track t) {
                            <mat-option [value]="t.valor_dato">
                              {{ t.descripl_dato }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (this.formAltaTercero.get('estatus').hasError('required')) {
                          <mat-error>
                            Campo requerido
                          </mat-error>
                        }
                        @if (this.formAltaTercero.get('estatus').hasError('importeInvalido')) {
                          <mat-error>
                            Campo requerido
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                  @if (![4, 6,7,8].includes(this.formAltaTercero.get('tipoTercero').value) && [5,6].includes(this.formAltaTercero.get('estatus').value)) {
                    <div [ngClass]="![1].includes(this.formAltaTercero.get('tipoTercero').value) ? 'col-md-12' : 'col-md-12'"
                      >
                      <mat-form-field class="inputFormularioSmall">
                        <mat-label>Estimación RC Bienes:</mat-label>
                        <input matInput type="text" formControlName="importe" formatoMoneda
                          tipoFormato="moneda">
                        </mat-form-field>
                      </div>
                    }
                  </div>
                </div>
                <div class="col md-6">
                  <div class="row">
                    @if (this.formAltaTercero.get('tipoTercero').value) {
                      @if ([1].includes(this.formAltaTercero.get('tipoTercero').value)) {
                        <div class="col-md-12"
                          >
                          <div class="col-md-12 d-flex align-items-center gap-1">
                            <mat-form-field class="inputFormularioSmall">
                              <mat-label>Categoría:</mat-label>
                              <mat-select formControlName="categoria" placeholder="Seleccionar">
                                @for (t of catCategorias; track t) {
                                  <mat-option [value]="t.valor_dato">
                                    {{ t.descripl_dato }}
                                  </mat-option>
                                }
                              </mat-select>@if (this.formAltaTercero.get('categoria').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                          <button style="margin-top:-20px" mat-mini-fab color="accent"
                            (click)="abrirModalVehiculos()">
                            <mat-icon>search</mat-icon>
                          </button>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>Modelo:</mat-label>
                            <mat-select formControlName="modelo" placeholder="Seleccionar">
                              @for (t of catModelo; track t) {
                                <mat-option [value]="t.modelo">
                                  {{ t.modelo }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (this.formAltaTercero.get('modelo').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>Marca:</mat-label>
                            <mat-select formControlName="marca" placeholder="Seleccionar">
                              @for (t of catMarcasVehiculos; track t) {
                                <mat-option
                                  [value]="t.cve_marca">
                                  {{ t.des_marca }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (this.formAltaTercero.get('marca').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>SubTipo:</mat-label>
                            <mat-select formControlName="subTipo" placeholder="Seleccionar">
                              @for (t of catSubTipoVehiculos; track t) {
                                <mat-option
                                  [value]="t.cve_subtipo">
                                  {{ t.descripcion }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (this.formAltaTercero.get('subTipo').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>Vehículo:</mat-label>
                            <mat-select formControlName="vehiculo" placeholder="Seleccionar">
                              @for (t of catVehiculos; track t) {
                                <mat-option [value]="t.cve_vehiculo">
                                  {{ t.des_vehiculo }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (this.formAltaTercero.get('vehiculo').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>Color:</mat-label>
                            <mat-select formControlName="color" placeholder="Seleccionar">
                              @for (t of catColores; track t) {
                                <mat-option [value]="t.color_id">
                                  {{ t.descripcion }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (this.formAltaTercero.get('color').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall">
                            <mat-label>Placas:</mat-label>
                            <input matInput type="text" formControlName="placas" maxlength="7">
                            @if (this.formAltaTercero.get('placas').hasError('required')) {
                              <mat-error
                                >
                                Campo requerido
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-md-12">
                          <mat-form-field class="inputFormularioSmall"
                            [ngClass]="cesvi.estatus_cesvi == 1 ? 'bg-serie-verde' : ''">
                            <mat-label>Serie:@if (cesvi.estatus_cesvi == 1) {
                              <span class="txt-exito"
                              [innerHTML]="verificaSerieHTMLSa"></span>
                            }
                          </mat-label>
                          <input matInput type="text" formControlName="serie" maxlength="17" UpperCase>
                          @if (formAltaTercero.get('serie')?.hasError('required')) {
                            <mat-error>
                              Campo requerido
                            </mat-error>
                          }
                          @if (formAltaTercero.get('serie')?.hasError('incorrecta')) {
                            <mat-icon class="txt-error hand-cursor"
                              matSuffix #menuTrigger="matMenuTrigger" [matMenu]
                              (click)="menuTrigger.openMenu()" [matMenuTriggerFor]="menu">
                              error_outline
                            </mat-icon>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-md-12">
                        <mat-form-field class="inputFormularioSmall">
                          <mat-label>Motor:</mat-label>
                          <input matInput type="text" formControlName="motor"  [UpperCase]="true">
                        </mat-form-field>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<mat-menu #menu="matMenu" yPosition="above" xPosition="before">
  <div [innerHTML]="verificaSerieHTMLSa"></div>
</mat-menu>